import { useEffect } from 'react';
import { Button, Spin, Avatar } from 'antd';
import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import css from './WaitingState.module.less';

interface WaitingStateProps {
  userName?: string;
  userAvatar?: string;
  onRetry: () => void;
  pollIntervalMs?: number;
}

export function WaitingState({
  userName,
  userAvatar,
  onRetry,
  pollIntervalMs = 15_000,
}: WaitingStateProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const id = window.setInterval(onRetry, pollIntervalMs);
    return () => window.clearInterval(id);
  }, [onRetry, pollIntervalMs]);

  return (
    <div className={css.waiting}>
      <Avatar
        size={64}
        src={userAvatar}
        icon={!userAvatar ? <UserOutlined /> : undefined}
        className={css.avatar}
      />
      <div className={css.name}>{userName ?? ''}</div>
      <div className={css.message}>
        {t('share.waiting', {
          defaultValue: "{{name}} hasn't started broadcasting yet. We'll load it as soon as it starts.",
          name: userName || '',
        })}
      </div>
      <Spin indicator={<LoadingOutlined spin />} className={css.spinner} />
      <Button type="primary" onClick={onRetry} className={css.retryBtn}>
        {t('share.waiting.retry', { defaultValue: 'Retry now' })}
      </Button>
    </div>
  );
}
